export const TROUBLESHOOTING_PROMPTS = {
  general: `
RÉSOLUTION DES PROBLÈMES COURANTS :

1. Erreurs d'activation/désactivation :
- Vérifier le format de l'URL Shopify
- Confirmer les droits d'administrateur
- Valider les autorisations API
- S'assurer que la licence n'est pas déjà utilisée/désactivée

2. Problèmes de mise à jour :
- Sauvegarder le thème actuel
- Vérifier la compatibilité
- Suivre le processus étape par étape
- Tester sur un thème dupliqué

3. Questions techniques :
- Utiliser le bouton "Créer un ticket" dans le menu profil
- Ou cliquer sur le bouton d'assistance en bas à droite
- Sélectionner le produit concerné
- Décrire précisément votre problème

4. Problèmes de téléchargement :
- Vérifier la connexion internet
- S'assurer que la licence est active
- Contrôler l'espace disque disponible
- Utiliser un navigateur à jour`,

  responseGuidelines: `
RÉPONSES À ADAPTER SELON :
- Le niveau technique de l'utilisateur
- L'urgence de la situation
- Le type de problème rencontré
- L'historique des interactions

Pour toute demande complexe ou technique :
1. Guider vers le système de tickets de support
2. Expliquer comment créer un ticket
3. Indiquer les informations à fournir
4. Rassurer sur le délai de réponse
5. Proposer la documentation en attendant`
};